import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import styles from '../FormTemplateBuilderForm/FormTemplateBuilderForm.module.scss';

interface Props {
  loading?: boolean;
  onCancelForm: () => void;
}

function FormTemplateBuilderActions({ loading, onCancelForm }: Props) {
  const { t } = useTranslation();
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      disabled={loading}
      fullWidth
      leftIcon="close"
      onClick={onCancelForm}
    />,
    <Button
      buttonText={t('save-template')}
      buttonType={ButtonTypes.primaryFilled}
      disabled={loading}
      fullWidth
      leftIcon="check"
      type="submit"
    />,
  ];
  return <ActionsRow actions={actions} className={styles.actions} />;
}

export default FormTemplateBuilderActions;
